import * as css from './WhatsAppCard.css';
import React from 'react';
interface WhatsAppCardProps {
    title: string;
    subtitle?: string;
    children: React.ReactNode;
    smallTitle: string;
    note: string;
}

export const DataSection: React.FC<{
    number: string;
    boldText: string;
    regularText: string;
}> = ({number, boldText, regularText}) => (
    <css.dataSection>
        <css.cardNumber>{number}</css.cardNumber>
        <css.cardBoldText>{boldText}</css.cardBoldText>
        <css.cardRegularText>{regularText}</css.cardRegularText>
    </css.dataSection>
);

function WhatsAppCard({
    title,
    subtitle,
    children,
    smallTitle,
    note
}: WhatsAppCardProps) {
    return (
        <css.card>
            <css.cardSection>
                <css.cardTitle>{title}</css.cardTitle>
                <css.cardSubtitle>{subtitle || ''}</css.cardSubtitle>
            </css.cardSection>
            <css.cardMainSection>
                {children}
            </css.cardMainSection>
            <css.cardBottomSection>
                <css.cardSmallTitle>{smallTitle}</css.cardSmallTitle>
                <css.cardNote>{note}</css.cardNote>
            </css.cardBottomSection>
        </css.card>
    );
}

export default WhatsAppCard; 